import {
  AccessTime,
  Adb,
  Add,
  Addchart,
  AddCircle,
  AddCircleOutline,
  AddCircleOutlined,
  AddToDrive,
  AltRoute,
  ApiOutlined,
  Archive,
  ArrowBack,
  ArrowDropDown,
  ArrowDropUp,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  Article,
  AssignmentIndOutlined,
  AttachMoney,
  AutoAwesome,
  AutoFixHighOutlined,
  Block,
  Bolt,
  CalendarMonth,
  CandlestickChart,
  CandlestickChartOutlined,
  ChatBubbleOutline,
  CheckCircle,
  CheckCircleOutlined,
  Checklist,
  ChevronLeft,
  ChevronRight,
  ChildCare,
  Close,
  CloudOff,
  CloudOutlined,
  Comment,
  CompareArrows,
  Construction,
  Contacts,
  ContentCopy,
  CorporateFare,
  Cottage,
  Dashboard,
  DataArray,
  Dataset,
  Delete,
  DeleteForever,
  Description,
  Done,
  Download,
  DragHandle,
  DragIndicator,
  EditOutlined,
  Equalizer,
  Error,
  ErrorOutlineRounded,
  EventNote,
  Explore,
  FormatListBulleted,
  ForwardToInbox,
  Fullscreen,
  FullscreenExit,
  GppGood,
  Grading,
  Group,
  HelpOutlineOutlined,
  HelpRounded,
  History,
  Home,
  Image,
  InfoOutlined,
  Insights as InsightsIcon,
  IntegrationInstructionsOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  KeyOutlined,
  Language,
  Layers,
  LocalPostOffice,
  Lock,
  Login,
  Logout,
  Mail,
  MailOutline,
  Map as MapIcon,
  MenuBook,
  MenuOpen,
  ModelTraining,
  MoreHoriz,
  MoreVert,
  NoteAddRounded,
  NotificationsNone,
  OnlinePrediction,
  Palette,
  PeopleAlt,
  Person,
  Phone,
  PhotoLibrary,
  PictureAsPdfOutlined,
  PriorityHigh,
  QueryStats,
  ReceiptLong,
  Refresh,
  Remove,
  Replay,
  ReportProblem,
  Route,
  Save,
  Schema,
  School,
  Science,
  Search,
  Send,
  Settings,
  SmartDisplay,
  Smartphone,
  Source,
  Storage,
  SupervisorAccount,
  SwitchAccount,
  Sync,
  SyncAlt,
  TableChart,
  TableRows,
  TableView,
  Tag,
  TextFields,
  ToggleOn,
  Topic,
  Troubleshoot,
  Tune,
  Unarchive,
  UnfoldLess,
  UnfoldMore,
  VideoLibrary,
  VisibilityOffOutlined,
  VisibilityOutlined,
  Warning,
  WarningAmber,
  WarningAmberOutlined,
  Web,
  WidthWide,
} from '@mui/icons-material';
import {
  Book,
  Brain,
  CircleDashed,
  CircleFadingArrowUp,
  ClipboardPaste,
  FileText,
  Plus,
  Target,
  Trash,
  Database as WarehouseDatabase,
  Table2 as WarehouseTable,
} from 'lucide-react';

import {AwsSqs} from './components/aws_sqs.js';
import {BigQuery} from './components/big_query.js';
import {Claude} from './components/claude.js';
import {Criteria} from './components/criteria.js';
import {DatabaseUpload} from './components/database_upload.js';
import {Database} from './components/database.js';
import {Databricks} from './components/databricks.js';
import {DatasetIcon} from './components/dataset_icon.js';
import {Destination} from './components/destination.js';
import {Experiment} from './components/experiment.js';
import {Gemini} from './components/gemini.js';
import {Kafka} from './components/kafka.js';
import {ObjectCreate} from './components/object_create.js';
import {OpenAI} from './components/openai.js';
import {Pubsub} from './components/pubsub.js';
import {RedShift} from './components/red_shift.js';
import {Snowflake} from './components/snowflake.js';
import {Spanner} from './components/spanner.js';
import {SqlServer} from './components/sql_server.js';
import {Stardust} from './components/stardust.js';
import {VertexAI} from './components/vertex_ai.js';
import type {IconsType} from './domain.js';

export const Icons = {
  adb: {
    provider: 'material',
    component: Adb,
  },
  add: {
    provider: 'material',
    component: Add,
  },
  addChart: {
    provider: 'material',
    component: Addchart,
  },
  addCircleFilled: {
    provider: 'material',
    component: AddCircle,
  },
  addCircle: {
    provider: 'material',
    component: AddCircleOutline,
  },
  addCircleOutline: {
    provider: 'material',
    component: AddCircleOutline,
  },
  addCircleOutlined: {
    provider: 'material',
    component: AddCircleOutlined,
  },
  accessTime: {
    provider: 'material',
    component: AccessTime,
  },
  altRoute: {
    provider: 'material',
    component: AltRoute,
  },
  article: {
    provider: 'material',
    component: Article,
  },
  api: {
    provider: 'material',
    component: ApiOutlined,
  },
  archive: {
    provider: 'material',
    component: Archive,
  },
  arrowBack: {
    provider: 'material',
    component: ArrowBack,
  },
  arrowForward: {
    provider: 'material',
    component: ArrowForward,
  },
  arrowLeft: {
    provider: 'material',
    component: ArrowLeft,
  },
  arrowRight: {
    provider: 'material',
    component: ArrowRight,
  },
  assignmentIndOutlined: {
    provider: 'material',
    component: AssignmentIndOutlined,
  },
  block: {
    provider: 'material',
    component: Block,
  },
  bolt: {
    provider: 'material',
    component: Bolt,
  },
  book: {
    provider: 'lucide',
    component: Book,
  },
  autoAwesome: {
    provider: 'material',
    component: AutoAwesome,
  },
  brain: {
    provider: 'lucide',
    component: Brain,
  },
  calendar: {
    provider: 'material',
    component: CalendarMonth,
  },
  candlestickChart: {
    provider: 'material',
    component: CandlestickChart,
  },
  checklist: {
    provider: 'material',
    component: Checklist,
  },
  childCare: {
    provider: 'material',
    component: ChildCare,
  },
  checkmark: {
    provider: 'material',
    component: Done,
  },
  chevronRight: {
    provider: 'material',
    component: ChevronRight,
  },
  circle_check_filled: {
    provider: 'material',
    component: CheckCircle,
  },
  circle_dashed: {
    provider: 'lucide',
    component: CircleDashed,
  },
  checkCircleOutlined: {
    provider: 'material',
    component: CheckCircleOutlined,
  },
  claude: {
    provider: 'local',
    component: Claude,
  },
  close: {
    provider: 'material',
    component: Close,
  },
  cloudOff: {
    provider: 'material',
    component: CloudOff,
  },
  cloudOutlined: {
    provider: 'material',
    component: CloudOutlined,
  },
  compareArrows: {
    provider: 'material',
    component: CompareArrows,
  },
  construction: {
    provider: 'material',
    component: Construction,
  },
  contacts: {
    provider: 'material',
    component: Contacts,
  },
  comment: {
    provider: 'material',
    component: Comment,
  },
  chatBubbleOutline: {
    provider: 'material',
    component: ChatBubbleOutline,
  },
  corporateFare: {
    provider: 'material',
    component: CorporateFare,
  },
  cottage: {
    provider: 'material',
    component: Cottage,
  },
  copy: {
    provider: 'material',
    component: ContentCopy,
  },
  criteria: {
    provider: 'local',
    component: Criteria,
  },
  dashboard: {
    provider: 'material',
    component: Dashboard,
  },
  dataArray: {
    provider: 'material',
    component: DataArray,
  },
  destination: {
    provider: 'local',
    component: Destination,
  },
  document: {
    provider: 'material',
    component: Description,
  },
  database: {
    provider: 'local',
    component: Database,
  },
  databaseUpload: {
    provider: 'local',
    component: DatabaseUpload,
  },
  dataset: {
    provider: 'material',
    component: Dataset,
  },
  datasetIcon: {
    provider: 'local',
    component: DatasetIcon,
  },
  delete: {
    provider: 'material',
    component: Delete,
  },
  deleteForever: {
    provider: 'material',
    component: DeleteForever,
  },
  done: {
    provider: 'material',
    component: Done,
  },
  down: {
    provider: 'material',
    component: KeyboardArrowDown,
  },
  download: {
    provider: 'material',
    component: Download,
  },
  dragHandle: {
    provider: 'material',
    component: DragHandle,
  },
  dragIndicator: {
    provider: 'material',
    component: DragIndicator,
  },
  editOutlined: {
    provider: 'material',
    component: EditOutlined,
  },
  error: {
    provider: 'material',
    component: Error,
  },
  errorOutlineRounded: {
    provider: 'material',
    component: ErrorOutlineRounded,
  },
  equalizer: {
    provider: 'material',
    component: Equalizer,
  },
  event: {
    provider: 'material',
    component: EventNote,
  },
  experiment: {
    provider: 'local',
    component: Experiment,
  },
  explore: {
    provider: 'material',
    component: Explore,
  },
  file: {
    provider: 'lucide',
    component: FileText,
  },
  forwardToInbox: {
    provider: 'material',
    component: ForwardToInbox,
  },
  gdrive: {
    provider: 'material',
    component: AddToDrive,
  },
  gemini: {
    provider: 'local',
    component: Gemini,
  },
  grading: {
    provider: 'material',
    component: Grading,
  },
  group: {
    provider: 'material',
    component: Group,
  },
  history: {
    provider: 'material',
    component: History,
  },
  home: {
    provider: 'material',
    component: Home,
  },
  infoOutlined: {
    provider: 'material',
    component: InfoOutlined,
  },
  warningOutlined: {
    provider: 'material',
    component: WarningAmberOutlined,
  },
  insightsIcon: {
    provider: 'material',
    component: InsightsIcon,
  },
  image: {
    provider: 'material',
    component: Image,
  },
  kafka: {
    provider: 'local',
    component: Kafka,
  },
  awsSqs: {
    provider: 'local',
    component: AwsSqs,
  },
  bigquery: {
    provider: 'local',
    component: BigQuery,
  },
  pubsub: {
    provider: 'local',
    component: Pubsub,
  },
  snowflake: {
    provider: 'local',
    component: Snowflake,
  },
  redshift: {
    provider: 'local',
    component: RedShift,
  },
  databricks: {
    provider: 'local',
    component: Databricks,
  },
  sqlserver: {
    provider: 'local',
    component: SqlServer,
  },
  spanner: {
    provider: 'local',
    component: Spanner,
  },
  keyOutlined: {
    provider: 'material',
    component: KeyOutlined,
  },
  language: {
    provider: 'material',
    component: Language,
  },
  layers: {
    provider: 'material',
    component: Layers,
  },
  list: {
    provider: 'material',
    component: FormatListBulleted,
  },
  chevronLeft: {
    provider: 'material',
    component: ChevronLeft,
  },
  lock: {
    provider: 'material',
    component: Lock,
  },
  localPostOffice: {
    provider: 'material',
    component: LocalPostOffice,
  },
  login: {
    provider: 'material',
    component: Login,
  },
  logout: {
    provider: 'material',
    component: Logout,
  },
  approve: {
    provider: 'material',
    component: GppGood,
  },
  plan: {
    provider: 'material',
    component: MapIcon,
  },
  mail: {
    provider: 'material',
    component: Mail,
  },
  mailOutlined: {
    provider: 'material',
    component: MailOutline,
  },
  magicWand: {
    provider: 'material',
    component: AutoFixHighOutlined,
  },
  modelTraining: {
    provider: 'material',
    component: ModelTraining,
  },
  moreHoriz: {
    provider: 'material',
    component: MoreHoriz,
  },
  moreVert: {
    provider: 'material',
    component: MoreVert,
  },
  onlinePredicton: {
    provider: 'material',
    component: OnlinePrediction,
  },
  attachMoney: {
    provider: 'material',
    component: AttachMoney,
  },
  palette: {
    provider: 'material',
    component: Palette,
  },
  paste: {
    provider: 'lucide',
    component: ClipboardPaste,
  },
  pdf: {
    provider: 'material',
    component: PictureAsPdfOutlined,
  },
  people: {
    provider: 'material',
    component: PeopleAlt,
  },
  photoLibrary: {
    provider: 'material',
    component: PhotoLibrary,
  },
  person: {
    provider: 'material',
    component: Person,
  },
  phone: {
    provider: 'material',
    component: Phone,
  },
  plus: {
    provider: 'lucide',
    component: Plus,
  },
  presentation: {
    provider: 'material',
    component: WidthWide,
  },
  queryStats: {
    provider: 'material',
    component: QueryStats,
  },
  refresh: {
    provider: 'material',
    component: Refresh,
  },
  remove: {
    provider: 'material',
    component: Remove,
  },
  replay: {
    provider: 'material',
    component: Replay,
  },
  reportProblem: {
    provider: 'material',
    component: ReportProblem,
  },
  route: {
    provider: 'material',
    component: Route,
  },
  schema: {
    provider: 'material',
    component: Schema,
  },
  school: {
    provider: 'material',
    component: School,
  },
  science: {
    provider: 'material',
    component: Science,
  },
  search: {
    provider: 'material',
    component: Search,
  },
  save: {
    provider: 'material',
    component: Save,
  },
  send: {
    provider: 'material',
    component: Send,
  },
  settings: {
    provider: 'material',
    component: Settings,
  },
  smartDisplay: {
    provider: 'material',
    component: SmartDisplay,
  },
  smartphone: {
    provider: 'material',
    component: Smartphone,
  },
  source: {
    provider: 'material',
    component: Source,
  },
  spreadsheet: {
    provider: 'material',
    component: TableView,
  },
  stardust: {
    provider: 'local',
    component: Stardust,
  },
  storage: {
    provider: 'material',
    component: Storage,
  },
  supervisorAccount: {
    provider: 'material',
    component: SupervisorAccount,
  },
  switchAccount: {
    provider: 'material',
    component: SwitchAccount,
  },
  sync: {
    provider: 'material',
    component: Sync,
  },
  syncAlt: {
    provider: 'material',
    component: SyncAlt,
  },
  table: {
    provider: 'material',
    component: TableRows,
  },
  tag: {
    provider: 'material',
    component: Tag,
  },
  target: {
    provider: 'lucide',
    component: Target,
  },
  toggle: {
    provider: 'material',
    component: ToggleOn,
  },
  transaction: {
    provider: 'material',
    component: ReceiptLong,
  },
  trash: {
    provider: 'lucide',
    component: Trash,
  },
  tune: {
    provider: 'material',
    component: Tune,
  },
  unarchive: {
    provider: 'material',
    component: Unarchive,
  },
  up: {
    provider: 'material',
    component: KeyboardArrowUp,
  },
  upload: {
    provider: 'lucide',
    component: CircleFadingArrowUp,
  },
  vertexai: {
    provider: 'local',
    component: VertexAI,
  },
  video: {
    provider: 'material',
    component: VideoLibrary,
  },
  visibilityOutlined: {
    provider: 'material',
    component: VisibilityOutlined,
  },
  visibilityOffOutlined: {
    provider: 'material',
    component: VisibilityOffOutlined,
  },
  warehouseDatabase: {
    provider: 'lucide',
    component: WarehouseDatabase,
  },
  warehouseTable: {
    provider: 'lucide',
    component: WarehouseTable,
  },
  warningAmber: {
    provider: 'material',
    component: WarningAmber,
  },
  warning: {
    provider: 'material',
    component: Warning,
  },
  web: {
    provider: 'material',
    component: Web,
  },
  noteAdd: {
    provider: 'material',
    component: NoteAddRounded,
  },
  notificationsNone: {
    provider: 'material',
    component: NotificationsNone,
  },
  menuOpen: {
    provider: 'material',
    component: MenuOpen,
  },
  menuBook: {
    provider: 'material',
    component: MenuBook,
  },
  text: {
    provider: 'material',
    component: TextFields,
  },
  help: {
    provider: 'material',
    component: HelpOutlineOutlined,
  },
  helpRounded: {
    provider: 'material',
    component: HelpRounded,
  },
  objectCreate: {
    provider: 'local',
    component: ObjectCreate,
  },
  openai: {
    provider: 'local',
    component: OpenAI,
  },
  topic: {
    provider: 'material',
    component: Topic,
  },
  expand: {
    provider: 'material',
    component: UnfoldMore,
  },
  fullscreen: {
    provider: 'material',
    component: Fullscreen,
  },
  fullscreenExit: {
    provider: 'material',
    component: FullscreenExit,
  },
  collapse: {
    provider: 'material',
    component: UnfoldLess,
  },
  candlestickChartOutlined: {
    provider: 'material',
    component: CandlestickChartOutlined,
  },
  integrationOutlined: {
    provider: 'material',
    component: IntegrationInstructionsOutlined,
  },
  tableChart: {
    provider: 'material',
    component: TableChart,
  },
  arrowDropDown: {
    provider: 'material',
    component: ArrowDropDown,
  },
  arrowDropUp: {
    provider: 'material',
    component: ArrowDropUp,
  },
  troubleshoot: {
    provider: 'material',
    component: Troubleshoot,
  },
  priorityHigh: {
    provider: 'material',
    component: PriorityHigh,
  },
} satisfies IconsType;

export type Icons = keyof typeof Icons;

export function isIcon(name: string): name is Icons {
  return Object.keys(Icons).includes(name);
}
